import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/GLPERP/GLPERP/apps/sales-portal/components/organisms/forms/Login.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/GLPERP/GLPERP/apps/sales-portal/public/assets/images/section-bg.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/GLPERP/GLPERP/node_modules/.pnpm/next@15.5.15_@babel+core@7.29.0_@playwright+test@1.59.1_react-dom@19.3.0_react@19.3.0__react@19.3.0_sass@1.99.0/node_modules/next/dist/client/image-component.js");
